/**
 * Retourne une copie de l'objet passé en parametre après avoir supprimé
 * les clés définies par le second parametre (string ou string[])
 */
export const omit = <T, K extends keyof T>(data: T, keys: K | K[]): Omit<T, K> => {
  const result = { ...data };
  const fields = Array.isArray(keys) ? keys : [keys];
  fields.forEach(key => delete result[key]);
  return result;
};

/**
 * Retourne une copie de l'objet passé en parametre après avoir supprimé
 * les clés définies par le second parametre (string ou string[])
 */
export const pick = <T, K extends keyof T>(data: T, keys: K[]): Pick<T, K> => {
  const result = {} as Pick<T, K>;
  keys.forEach(key => {
    result[key] = data[key];
  });
  return result;
};

/**
 * Retourne une copie de l'objet passé en parametre après avoir supprimé
 * les clés définies par le second parametre (string ou string[])
 */
export const omitBy = <T extends object, V = T[keyof T]>(
  obj: T,
  predicate: (value: V) => boolean,
): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => !predicate(value as V)),
  ) as Partial<T>;
};

export const isNil = (value: unknown): value is null | undefined =>
  value === null || value === undefined;
